// useFileUpload.ts
import FileUploadService from "@/integrations/service/FileUploadService.service";
import { useMutation } from "@tanstack/react-query";

export const useUploadImage = () => {
  return useMutation({
    mutationFn: FileUploadService.uploadImage,
  });
};

export const useUploadVideo = () => {
  return useMutation({
    mutationFn: FileUploadService.uploadVideo,
  });
};

export const useUploadDocument = () => {
  return useMutation({
    mutationFn: FileUploadService.uploadDocument,
  });
};